import React from "react";
import "./BRACES_ORTHODONTICS.css";
import Teeth_Whiting_img from "../images/braces-3597591_1920.jpg";
function BRACES_ORTHODONTICS() {
  return (
    <div className="container_Teeth_Service_Braces">
      <h1>BRACES & ORTHODONTICS</h1>
      <div className="teeth_img_upper_box_Service_Braces">
        <img
          src={Teeth_Whiting_img}
          className="img_of_home_Service_Braces"
          alt=""
        />
      </div>
      <div className="teeth_text_upper_main_Service_Braces">
        <p>
          Orthodontics is a speciality of dentistry that deals with the
          diagnosis, prevention and correction of faulty positioned teeth and
          jaws. Orthodontics is the part of dentistry that adjusts teeth and
          jaws that are situated inappropriately. Abnormal teeth and teeth that
          don't fit together accurately are harder to keep clean which can lead
          to cerebral pains. Teeth that are not in the correct place can degrade
          one's physical appearance as well. The advantages of orthodontic
          treatment incorporate a favourable mouth, an additionally satisfying
          appearance, and teeth that will probably endure forever. Dental braces
          (otherwise called props, orthodontic cases, or cases) are utilized in
          orthodontics that adjust and rectify teeth and help position them with
          respect to one’s chewing habits intending to enhance dental wellbeing.
        </p>
        <h1>DID YOU KNOW??</h1>
        <p>
          Grown-ups need straight teeth as well! Indeed, MILLIONS of individuals
          over age 18 are at present in orthodontic treatment. Braces are not
          magnetic, they don't get radio transmissions and don't expand your
          chances of being hit by lightning!
        </p>
        <div className="FAQ_Service_Braces">
          <h2>FAQ'S</h2>
        </div>
      </div>
    </div>
  );
}
export default BRACES_ORTHODONTICS;
